export const GET_BTN_FILTER = 'GET_BTN_FILTER'
export const SET_BTN_FILTER = 'SET_BTN_FILTER'
export const GET_FOUND_CALENDAR = 'GET_FOUND_CALENDAR'
export const SET_FOUND_CALENDAR = 'SET_FOUND_CALENDAR'

export const SET_CALENDAR = 'SET_CALENDAR'
export const GET_CURRENT_YEAR = 'GET_CURRENT_YEAR'
export const GET_CURRENT_MONTH = 'GET_CURRENT_MONTH'
export const GET_CURRENT_DATE = 'GET_CURRENT_DATE'
export const GET_CURRENT_DAY = 'GET_CURRENT_DAY'

export const GET_SELECTING_YEAR = 'GET_SELECTING_YEAR'
export const SET_SELECTING_YEAR = 'SET_SELECTING_YEAR'
export const GET_SELECTING_MONTH = 'GET_SELECTING_MONTH'
export const SET_SELECTING_MONTH = 'SET_SELECTING_MONTH'
export const GET_SELECTING_DATE = 'GET_SELECTING_DATE'
export const SET_SELECTING_DATE = 'SET_SELECTING_DATE'

export const GET_SELECTED_YEAR = 'GET_SELECTED_YEAR'
export const GET_SELECTED_MONTH = 'GET_SELECTED_MONTH'
export const GET_SELECTED_DATE = 'GET_SELECTED_DATE'
export const GET_SELECTED_DAY = 'GET_SELECTED_DAY'
export const SET_ADD_DATE = 'SET_ADD_DATE'
export const SET_ADD_MONTH = 'SET_ADD_MONTH'

export const GET_DAYS = 'GET_DAYS'
export const GET_MONTH = 'GET_MONTH'
export const SET_CALENDAR_DISP = 'SET_CALENDAR_DISP'
export const GET_NEXT_PAGE = 'GET_NEXT_PAGE'
export const GET_FILTER_IMAGE = 'GET_FILTER_IMAGE'
export const SET_FILTER_IMAGE = 'SET_FILTER_IMAGE'
export const GET_FILTER_IMAGE_DISP = 'GET_FILTER_IMAGE_DISP'
export const SET_FILTER_IMAGE_DISP = 'SET_FILTER_IMAGE_DISP'
export const GET_MAIN_CALENDAR = 'GET_MAIN_CALENDAR'
export const GET_CALENDAR_TAB1_DISP = 'GET_CALENDAR_TAB1_DISP'
export const SET_CALENDAR_TAB1_DISP = 'SET_CALENDAR_TAB1_DISP'
export const GET_CALENDAR_TAB2_DISP = 'GET_CALENDAR_TAB2_DISP'
export const GET_CALENDAR_TAB3_DISP = 'GET_CALENDAR_TAB3_DISP'
export const GET_CALENDAR_TAB4_DISP = 'GET_CALENDAR_TAB4_DISP'
export const GET_CALENDAR_SWITCH = 'GET_CALENDAR_SWITCH'
export const SET_CALENDAR_SWITCH = 'SET_CALENDAR_SWITCH'

export const GET_DISABLE_CALENDAR_YEAR_BUTTON = 'GET_DISABLE_CALENDAR_YEAR_BUTTON'
export const SET_DISABLE_CALENDAR_YEAR_BUTTON = 'SET_DISABLE_CALENDAR_YEAR_BUTTON'
export const RECEIVED_ALL_CALENDARTAB = 'RECEIVED_ALL_CALENDARTAB'

export const SET_CALENDAR_TAB1 = 'SET_CALENDAR_TAB1'
export const GET_CALENDAR_TAB1 = 'GET_CALENDAR_TAB1'
export const RECEIVED_CALENDARTAB1 = 'RECEIVED_CALENDARTAB1'

export const SET_CALENDAR_TAB2 = 'SET_CALENDAR_TAB2'
export const GET_CALENDAR_TAB2 = 'GET_CALENDAR_TAB2'
export const RECEIVED_CALENDARTAB2 = 'RECEIVED_CALENDARTAB2'

export const SET_CALENDAR_TAB3 = 'SET_CALENDAR_TAB3'
export const GET_CALENDAR_TAB3 = 'GET_CALENDAR_TAB3'
export const RECEIVED_CALENDARTAB3 = 'RECEIVED_CALENDARTAB3'

export const SET_CALENDAR_TAB4 = 'SET_CALENDAR_TAB4'
export const GET_CALENDAR_TAB4 = 'GET_CALENDAR_TAB4'
export const RECEIVED_CALENDARTAB4 = 'RECEIVED_CALENDARTAB4'
export const SAVE_CALENDAR_TAB4 = 'SAVE_CALENDAR_TAB4'
export const POST_CALENDAR_TAB4 = 'POST_CALENDAR_TAB4'
export const DELETE_CALENDAR_TAB4 = 'DELETE_CALENDAR_TAB4'
export const POST_CALENDAR_TAB4_CHECKED = 'POST_CALENDAR_TAB4_CHECKED'

export const GET_CALENDAR_HOLIDAY = 'GET_CALENDAR_HOLIDAY'
export const SET_CALENDAR_HOLIDAY = 'SET_CALENDAR_HOLIDAY'

export const SET_CALENDAR_MAIN_BOOLEAN = 'SET_CALENDAR_MAIN_BOOLEAN'
export const SET_CALENDAR_MAIN = 'SET_CALENDAR_MAIN'
export const GET_CALENDAR_MAIN = 'GET_CALENDAR_MAIN'



// WEBPACK FOOTER //
// ./src/store/modules/calendar/mutation-types.js